import * as React from 'react';
import { InfoListItem, ChannelValue } from '@brightlayer-ui/react-components/core';
import { getIcon } from '../../lib/icons';
import { ChannelDatum } from '../../types';
import { getMetric } from '../../data/domain/metric-data-helpers';
import * as PXBColors from '@brightlayer-ui/colors';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function makeMetricListItem(
    titleFn: (value: ChannelDatum) => string,
    subtitleFn: (value: ChannelDatum) => string
) {
    const component: React.FC<{
        value: ChannelDatum;
        showIcon?: boolean;
        testId?: string;
        isLastItem?: boolean;
    }> = (props) => {
        const metric = getMetric(props.value);
        const TheIcon = getIcon(metric.icon, 'Clear');

        return (
            <div data-testid={props.testId}>
                <InfoListItem
                    dense
                    title={titleFn(props.value)}
                    subtitle={subtitleFn(props.value)}
                    divider={!props.isLastItem ? 'full' : undefined}
                    subtitleSeparator={'/'}
                    icon={props.showIcon ? <TheIcon style={{ color: PXBColors.gray[800] }} /> : undefined}
                    hidePadding={!props.showIcon}
                    rightComponent={
                        <ChannelValue  fontSize={15} value={metric.value || ''} units={metric.units} />
                    }
                />
            </div>
        );
    };

    return component;
}
